import React, {memo} from 'react';

import {Modal} from '@homeaway/react-modal';

// Modal.whyDidYouRender = true;

import {SearchDetailsFields} from '../SearchDetailsFields/SearchDetailsFields';

import {useComponent} from './hooks/useComponent';

import './SearchDetailsModal.less';

const SearchDetailsModal = memo(function SearchDetailsModal() {
    const {
        id,
        className,
        fixedBody,
        parentNode,
        portalClassName,
        isContextual,
        isInstructional,
        isWorkflow,
        renderBackdrop,
        header,
        title,
        closeButton,
        closeText,
        secondaryActionLabel,
        footer,
        isOpen,
        isLoading,
        secondaryActionDisabled,
        closeOnEsc,
        closeOnOutsideClick,
        modalAnimation,
        timeouts,
        scrollTop,
        scrollToTop,
        onClose,
        onModalOpen,
        onModalClose,
        secondaryActionCallback
    } = useComponent();

    return (
        <Modal
            id={id}
            className={className}
            fixedBody={fixedBody}
            parentNode={parentNode}
            portalClassName={portalClassName}
            isContextual={isContextual}
            isInstructional={isInstructional}
            isWorkflow={isWorkflow}
            renderBackdrop={renderBackdrop}
            header={header}
            title={title}
            closeButton={closeButton}
            closeText={closeText}
            secondaryActionLabel={secondaryActionLabel}
            footer={footer}
            isOpen={isOpen}
            isLoading={isLoading}
            secondaryActionDisabled={secondaryActionDisabled}
            closeOnEsc={closeOnEsc}
            closeOnOutsideClick={closeOnOutsideClick}
            modalAnimation={modalAnimation}
            timeouts={timeouts}
            scrollTop={scrollTop}
            scrollToTop={scrollToTop}
            onClose={onClose}
            onModalOpen={onModalOpen}
            onModalClose={onModalClose}
            secondaryActionCallback={secondaryActionCallback}
        >
            <SearchDetailsFields/>
        </Modal>
    );
});

SearchDetailsModal.whyDidYouRender = true;

export {SearchDetailsModal};
